import { ErrorHandler, Injectable, Optional } from '@angular/core';
import { AuthenticationStorageService } from '@core/storage/jwt-storage-service';
import * as Sentry from "@sentry/angular-ivy";
import { environment } from 'src/environments/environment';

Sentry.init({
  enabled: environment.production,
  ignoreErrors: ['ResizeObserver loop limit exceeded'],
  dsn: 'https://d8963b7e4ba04e1385a45a18a4c746d8@o72203.ingest.sentry.io/5199699',
  integrations: [
    // Registers and configures the Tracing integration,
    // which automatically instruments your application to monitor its
    // performance, including custom Angular routing instrumentation
    new Sentry.BrowserTracing({
      tracingOrigins: ['localhost', 'https://genius-cp-api.ats.careers/api/'],
      routingInstrumentation: Sentry.routingInstrumentation,
    }),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.2,
});

@Injectable({
  providedIn: 'root'
})

export class SentryErrorHandler implements ErrorHandler {
  constructor(@Optional() private _authenticationStorageService: AuthenticationStorageService) { }
  handleError(error) {
    let details = null;
    if (!!this._authenticationStorageService) {
      details = this._authenticationStorageService.getDetails();
    }

    const eventId = Sentry.captureException(error.originalError || error, {
      tags: !!details ? details : {}
    });

    Sentry.showReportDialog({ eventId });
    if (!environment.production) {
      throw error;
    }

  }
}
